/**
 * Angular imports
 */
import {Injectable} from 'angular2/core';

/**
 * App config
 */
import {App} from "../app_config";

/**
 * Model imports
 */
import {User} from "../models/user.model";

/**
 * Replace => import { Keycloak } from 'keycloak-js';
 * Not imported from 'keycloak-js' because source file has some errors
 * that create error in voucher front build
 */
declare var Keycloak: any;
// import Keycloak from 'keycloak-js';

/**
 * Keycloak service to interact with the keycloak portal
 * and manage the local user account
 */
@Injectable()
export class KeycloakService {
    static keycloakAuth: any;

    /**
     * Used to instantiate keycloak context and check login state
     *
     * @static - declared as static because keycloak service cannot be it cannot
     * be injected because the angular context does not yet exist
     * since the main component has not been bootstraped {@see app/main.ts}
     */
    public static init(): Promise<any> {
        const keycloakInstance = new Keycloak(App.AppConfig.keycloakConfig);
        return new Promise((resolve: any) => {
            keycloakInstance.init({
                onLoad: 'login-required',
                checkLoginIframe: false
            }).then(() => {
                KeycloakService.keycloakAuth = keycloakInstance;

                setInterval(() => {
                    console.timeStamp("Will refresh token !");
                    if (KeycloakService.keycloakAuth !== undefined) {
                        KeycloakService.keycloakAuth.updateToken(60).then((refreshed) => {
                            if (refreshed) {
                                console.log('Token refreshed');
                            }
                        }).catch(err => {
                            console.error('Failed to refresh token', err);
                        });
                    }
                }, 60000);

                resolve();
            }).catch((err: Error) => console.error('KeycloakService() => keycloak init failed:', err));
        });
    }

    /**
     * Remove the local user and redirect to keycloak
     */
    public logout() {
        KeycloakService.keycloakAuth.logout();
    }

    /**
     * Redirects to the Keycloak account management portal
     */
    public manageAccount() {
        KeycloakService.keycloakAuth.accountManagement();
    }

    /**
     * Retrieves current user token
     */
    public getToken(): string {
        return KeycloakService.keycloakAuth.token;
    }

    /**
     * Retrieves current user data
     */
    public getUser(): User {
        const token = KeycloakService.keycloakAuth.tokenParsed;

        // @ts-ignore
        return new User({
            id: null,
            firstName: token.given_name,
            lastName: token.family_name,
            email: token.email,
            roles: token.resource_access[App.AppConfig.keycloakConfig.clientId].roles,
            canal: null,
            language: token.locale,
            activated: null
        } as User);
    }
}
